export const AUDIO_ATTACHMENT_MIME_TYPES = [
  'audio/aac',
  'audio/flac',
  'audio/m4a',
  'audio/mp3',
  'audio/mp4',
  'audio/mpeg',
  'audio/ogg',
  'audio/opus',
  'audio/wav',
  'audio/wave',
  'audio/webm',
  'audio/x-flac',
  'audio/x-m4a',
  'audio/x-wav',
] as const;

export const AUDIO_ATTACHMENT_EXTENSIONS = [
  '.aac',
  '.flac',
  '.m4a',
  '.mp3',
  '.ogg',
  '.opus',
  '.wav',
  '.webm',
] as const;

export const AUDIO_TRANSCRIPTION_LIMITS = {
  chunkHardMaxSeconds: 240,
  chunkTargetMaxSeconds: 120,
  chunkTargetMinSeconds: 60,
  heartbeatSeconds: 15,
  jobMaxAttempts: 3,
  maxBatchDurationSeconds: 36_000,
  maxConcurrentParts: 3,
  maxConcurrentUploads: 2,
  maxDocumentFilesPerMessage: 3,
  maxDurationSeconds: 10_800,
  maxFilesPerMessage: 5,
  maxSizeBytes: 1_073_741_824,
  maxTotalAttachmentsPerMessage: 8,
  multipartPartSizeBytes: 33_554_432,
  previewMaxChars: 280,
  simplePutMaxBytes: 67_108_864,
  sourceRetentionDays: 30,
  stagingRetentionHours: 24,
  workerConcurrency: 1,
} as const;

export const AUDIO_TRANSCRIPTION_DEFAULT_PROMPT = [
  'Analyse les fichiers audio joints. Transcris-les fidèlement, distingue les',
  'intervenants lorsque c’est possible, puis produis une synthèse structurée avec',
  'les points clés, les décisions, les actions à mener et les questions ouvertes.',
  'Respecte les consignes et l’ordre que je précise ci-dessous, signale les',
  'passages incertains et n’invente aucune information.',
].join(' ');

export const AUDIO_TRANSCRIPTION_ONBOARDING_STORAGE_KEY_PREFIX =
  'inersio:audio-transcription-onboarding:v1:';
